import { client } from "./client";
import interceptors from "./interceptors";
import qs from "qs";

client.interceptors.request.use(interceptors.auth, interceptors.onError);

function getDataFreeTools(params) {
	return client.get("api/free-tools/data", {
		params: params,
	});
}

function exportFreeTools(params) {
	return client.get("api/free-tools/export", {
		params: params,
	});
}

function addFreeTools(params) {
	return client.post("api/free-tools/add", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function updateFreeTools(params) {
	return client.post("api/free-tools/edit", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function deleteFreeTools(params) {
	return client.post("api/free-tools/delete", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function optionProductInFreetools() {
	return client.get("api/options/free_tools");
}

function optionProduct() {
	return client.get("api/options/product");
}

export default {
	getDataFreeTools,
	exportFreeTools,
	addFreeTools,
	updateFreeTools,
	deleteFreeTools,
	optionProduct,
	optionProductInFreetools
};